import ApiClient from '@lib/apiClient';

export const fetchStatusCount = async () => {
	const { data } = await ApiClient.GET('getStatusCount');
	return data;
};

export const fetchDashboardOrderList = async (apiKey, queryParams) => {
	const { data } = await ApiClient.GET(apiKey, queryParams);
	return data;
};

export const getOrderByOrderDashboardId = async (queryParams) => {
	const { data } = await ApiClient.GET('getOrderDashboardReports', queryParams);
	return data;
};

export const completeOrderStepByIdList = async (postData) => {
	const { data } = await ApiClient.POST('completeOrderSteps', '', `?idList=${postData.join(',')}`);
	return data;
};

export const getOrderDashboardFilterOptions = async (queryParams) => {
	const { data } = await ApiClient.GET('getOrderDashboardFilterOptions', queryParams);
	return data;
};

export const getOrderDashboardFilterOptionSearch = async (queryParams) => {
	const { data } = await ApiClient.GET('getOrderDashboardFilterOptionSearch', queryParams);
	return data;
};
